(function () {
  'use strict';
  if (window.__pmNativeSearch) return;
  window.__pmNativeSearch = true;
  var input, panel, inner, results, glass, closeButton, form;
  var open = false, lock = null, pending = null, timer = null, version = 0, activeQuery = '';
  var mobile = window.matchMedia('(max-width:1023px), (max-width:1024px) and (pointer:coarse)');
  var raf = 0;

  function position() {
    raf = 0;
    if (!open) return;
    var header = document.querySelector('.pm-header-card') || document.querySelector('.site-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    var viewport = window.visualViewport;
    var visibleTop = viewport ? viewport.offsetTop : 0;
    var visibleBottom = visibleTop + (viewport ? viewport.height : window.innerHeight);
    var headerBottom = Math.max(visibleTop, rect.bottom);
    var top = headerBottom + (mobile.matches ? 8 : 0);
    // Keep the white canvas around the header outside the tinted search backdrop.
    glass.style.top = Math.round(headerBottom) + 'px';
    panel.style.top = Math.round(top) + 'px';
    panel.style.maxHeight = Math.max(60, visibleBottom - top - 8) + 'px';
    inner.style.setProperty('--pm-native-search-width', rect.width + 'px');
    // Match inset headers on tablets without removing the phone's minimum gutter.
    panel.style.left = mobile.matches ? Math.round(Math.max(12, rect.left)) + 'px' : '0px';
    panel.style.right = mobile.matches ? Math.round(Math.max(12, window.innerWidth - rect.right)) + 'px' : '0px';
  }
  function schedulePosition() {
    if (!raf) raf = requestAnimationFrame(position);
  }
  function lockPage() {
    if (lock || !mobile.matches) return;
    var body = document.body, x = window.scrollX, y = window.scrollY;
    lock = { x:x, y:y, properties:[] };
    var styles = {position:'fixed', top:-y+'px', left:-x+'px', right:'0', width:'100%', overflow:'hidden'};
    Object.keys(styles).forEach(function (name) {
      lock.properties.push({name:name, value:body.style.getPropertyValue(name), priority:body.style.getPropertyPriority(name), owned:styles[name]});
      body.style.setProperty(name, styles[name], 'important');
    });
  }
  function unlockPage() {
    if (!lock) return;
    var previous = lock; lock = null;
    previous.properties.forEach(function (item) {
      if (document.body.style.getPropertyValue(item.name) !== item.owned) return;
      if (item.value) document.body.style.setProperty(item.name,item.value,item.priority);
      else document.body.style.removeProperty(item.name);
    });
    window.scrollTo(previous.x, previous.y);
  }
  function toggle(next) {
    open = next;
    panel.hidden = !next; glass.hidden = !next;
    input.setAttribute('aria-expanded', String(next));
    document.documentElement.classList.toggle('pm-native-search-open', next);
    document.documentElement.classList.toggle('pm-search-ui-active', next);
    document.body.classList.toggle('pm-search-ui-active', next);
    document.documentElement.classList.toggle('pm-mobile-search-open', next && mobile.matches);
    if (next) { lockPage(); position(); }
    else { unlockPage(); input.removeAttribute('aria-activedescendant'); }
  }
  function dismiss(restoreFocus) {
    version++;
    clearTimeout(timer);
    if (pending) pending.abort();
    pending = null;
    input.removeAttribute('aria-busy');
    toggle(false);
    if (restoreFocus) input.focus({preventScroll:true});
    else input.blur();
  }
  async function search() {
    var terms = input.value.trim();
    var current = ++version;
    if (pending) pending.abort();
    if (!terms) { toggle(false); results.replaceChildren(); return; }
    pending = new AbortController();
    input.setAttribute('aria-busy','true');
    var url = new URL(input.dataset.pmSearchEndpoint || '/search/suggest', location.origin);
    url.searchParams.set('q',terms);
    url.searchParams.set('resources[type]','query,collection,product');
    url.searchParams.set('resources[limit]','5');
    url.searchParams.set('resources[limit_scope]','each');
    url.searchParams.set('resources[options][unavailable_products]','last');
    url.searchParams.set('section_id','pm-predictive-search');
    try {
      var response = await fetch(url, {signal:pending.signal});
      if (!response.ok) throw new Error('Search response unavailable');
      var parsed = new DOMParser().parseFromString(await response.text(),'text/html');
      var content = parsed.querySelector('[data-pm-search-response]');
      if (current !== version || terms !== input.value.trim()) return;
      if (!content) throw new Error('Search response missing');
      results.replaceChildren(content);
      activeQuery = terms;
      toggle(true);
    } catch (error) {
      if (error.name === 'AbortError' || current !== version) return;
      results.replaceChildren();
      var message = document.createElement('p');
      message.className = 'pm-search-empty'; message.textContent = input.dataset.pmSearchError;
      var link = document.createElement('a'); link.className = 'pm-search-all';
      link.href = form.action + '?q=' + encodeURIComponent(terms) + '&type=product';
      link.textContent = input.dataset.pmSearchViewAll;
      results.append(message,link); toggle(true);
    } finally {
      if (current === version) input.removeAttribute('aria-busy');
    }
  }
  function start() {
    input = document.querySelector('[data-pm-native-search-input]');
    if (!input) return;
    form = input.form;
    glass = document.createElement('div'); glass.className = 'pm-native-search-glass'; glass.hidden = true;
    panel = document.createElement('div'); panel.className = 'pm-native-search-panel'; panel.hidden = true;
    panel.setAttribute('role','region'); panel.setAttribute('aria-label',input.dataset.pmSearchLabel);
    inner = document.createElement('div'); inner.className = 'pm-native-search-inner';
    results = document.createElement('div'); results.id = 'pm-native-search-results';
    closeButton = document.createElement('button'); closeButton.type = 'button'; closeButton.className = 'pm-native-search-close';
    closeButton.setAttribute('aria-label',input.dataset.pmSearchClose);
    closeButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    inner.append(results,closeButton); panel.append(inner); document.body.append(glass,panel);
    input.setAttribute('role','combobox'); input.setAttribute('aria-autocomplete','list'); input.setAttribute('aria-controls',results.id); input.setAttribute('aria-expanded','false');
    input.addEventListener('input',function () {
      version++; clearTimeout(timer); if (pending) pending.abort();
      if (!input.value.trim()) { toggle(false); results.replaceChildren(); return; }
      timer = setTimeout(search,160);
    });
    input.addEventListener('pointerdown',function () {
      if (!open && input.value.trim()) {
        if (activeQuery === input.value.trim() && results.children.length) toggle(true);
        else search();
      }
    });
    input.addEventListener('keydown',function (event) {
      if (event.key === 'Escape') { event.preventDefault(); dismiss(true); }
      if (event.key === 'ArrowDown' && open) { event.preventDefault(); var first = results.querySelector('a'); if (first) first.focus(); }
    });
    panel.addEventListener('keydown',function (event) {
      if (event.key === 'Escape') { event.preventDefault(); dismiss(true); return; }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var links = Array.from(results.querySelectorAll('a')); var index = links.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      var next = index + (event.key === 'ArrowDown' ? 1 : -1);
      if (next < 0) input.focus({preventScroll:true}); else links[Math.min(next,links.length-1)].focus();
    });
    closeButton.addEventListener('click',function () { dismiss(false); });
    document.addEventListener('pointerdown',function (event) {
      if (!open || panel.contains(event.target) || form.contains(event.target)) return;
      dismiss(false);
    },true);
    form.addEventListener('submit',function () { dismiss(false); });
    var shop = document.querySelector('.pm-desktop-nav .navmenu-id-shop');
    if (shop) {
      ['mouseenter','mouseover','pointerenter','pointerover'].forEach(function (type) {
        shop.addEventListener(type,function (event) { if (open) event.stopImmediatePropagation(); },true);
      });
    }
    window.addEventListener('resize',schedulePosition,{passive:true});
    window.addEventListener('scroll',schedulePosition,{passive:true});
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize',schedulePosition,{passive:true});
      window.visualViewport.addEventListener('scroll',schedulePosition,{passive:true});
    }
    mobile.addEventListener('change',function () {
      if (!open) return;
      if (mobile.matches) lockPage(); else unlockPage();
      document.documentElement.classList.toggle('pm-mobile-search-open', mobile.matches);
      schedulePosition();
    });
    window.addEventListener('pagehide',function () { dismiss(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
